import { useI18n, type Lang } from "@/lib/i18n";

const OPTIONS: { lang: Lang; flag: string; label: string }[] = [
  { lang: "es", flag: "ES", label: "Español (Paraguay)" },
  { lang: "en", flag: "EN", label: "English" },
  { lang: "pt", flag: "PT", label: "Português (Brasil)" },
];

export function LanguageSwitcher({ className = "" }: { className?: string }) {
  const { lang, setLang, t } = useI18n();

  return (
    <div
      role="group"
      aria-label={t("lang.label")}
      className={`inline-flex items-center gap-0.5 rounded-md border border-border bg-background p-0.5 ${className}`}
    >
      {OPTIONS.map((o) => (
        <button
          key={o.lang}
          type="button"
          onClick={() => setLang(o.lang)}
          aria-label={o.label}
          title={o.label}
          aria-pressed={lang === o.lang}
          className={`rounded px-2 py-1 text-xs font-semibold leading-none transition ${
            lang === o.lang
              ? "bg-primary text-primary-foreground"
              : "text-muted-foreground hover:bg-secondary"
          }`}
        >
          <span aria-hidden="true">{o.flag}</span>
        </button>
      ))}
    </div>
  );
}
